import { Button } from '@sravni/react-design-system';
import type { ButtonProps } from '@sravni/react-design-system/lib/Button';

import { sendEventPreApprovedOfferClick } from 'shared/lib/sendGAEvents';

import { getOfferButtonText } from '../../lib/getOfferButtonText';

import { getOfferBankName } from './preApprovalOfferAdapters';
import type { TPreApprovalControlOffer } from './types';

type Props = {
  offer: TPreApprovalControlOffer;
  buttonProps?: ButtonProps;
};

export const StartStepFlowButton: FC<Props> = (props) => {
  const { offer, buttonProps } = props;
  const { onClick: onClickProp, ...otherButtonProps } = buttonProps || {};

  const onClickHandler = () => {
    sendEventPreApprovedOfferClick({
      bankName: getOfferBankName(offer),
      offerName: offer.productName,
    });
  };

  return (
    <Button
      {...otherButtonProps}
      block
      type="button"
      variant="primary"
      color="dark"
      onClick={(event) => {
        event.stopPropagation();
        onClickHandler();
        onClickProp?.(event);
      }}
    >
      {getOfferButtonText(offer)}
    </Button>
  );
};
